import React, { useEffect, useState } from 'react'
import Form, { ButtonItem, SimpleItem, ColCountByScreen, Label, GroupItem, EmptyItem } from 'devextreme-react/form'
import '../../../../../../../../constants/stylesheet.css'
import { useMediaQuery, Alert, Box, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const ChangeSearchImageUpload = (props) => {
    const isSubmitDisabled = !props.selectedFile
    const [labelLocation, setLabelLocation] = useState('left')
    const sm = useMediaQuery('(max-width:600px)')
    const DESIRED_IMAGE_WIDTH = 800
    const DESIRED_IMAGE_HEIGHT = 1300
    const [selectedPreviewUrl, setSelectedPreviewUrl] = useState(null)
    const hasExistingImage = Boolean(props.filePathSearchData && props.filePathSearchData !== '')

    useEffect(() => {
        setLabelLocation(sm ? 'top' : 'left')
    }, [sm])

    useEffect(() => {
        return () => {
            if (selectedPreviewUrl) URL.revokeObjectURL(selectedPreviewUrl)
        }
    }, [selectedPreviewUrl])

    const submitButtonOptionsSearch = {
        text: 'Add',
        type: 'default',
        width: 120,
        icon: 'check',
        useSubmitBehavior: true,
        disabled: isSubmitDisabled,
    }

    const deleteButtonOptionsSearch = {
        text: 'Delete',
        type: 'danger',
        width: 120,
        icon: 'trash',
        useSubmitBehavior: false,
        onClick: props.onRemoveSearchImage,
        disabled: !props.filePathSearchData,
    }

    const validationRules = {
        dateStart: [{ type: 'required', message: 'Date Start is required.' }],
        dateEnd: [{ type: 'required', message: 'Date End is required.' }],
        sortOrder: [{ type: 'required', message: 'Sort order is required.' }],
        file: [
            { type: 'required', message: 'Image is required.' },
            {
                type: 'custom',
                validationCallback: (e) => e.value[0]?.size <= 256 * 1024,
                message: 'Image should not be more than 256 KB.',
            },
        ],
    }

    return (
        <React.Fragment>
            <form action='' onSubmit={props.onAddSearchImage}>
                <Form
                    mode='form'
                    formData={props.searchImage}
                    showColonAfterLabel={false}
                    showValidationSummary={false}
                    labelLocation={labelLocation}>
                    <GroupItem cssClass='form-group-item'>
                        <ColCountByScreen lg={13} md={13} sm={1} xs={1} />
                        <GroupItem />
                        <GroupItem />
                        <GroupItem />
                        <GroupItem cssClass='form-group-item' colSpan={6}>
                            <EmptyItem />
                            <SimpleItem>
                                <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%', mb: 1 }}>
                                    <Alert
                                        severity='info'
                                        icon={<InfoOutlinedIcon fontSize='small' />}
                                        sx={{
                                            py: 0.5,
                                            maxWidth: 320,
                                            '& .MuiAlert-message': { fontSize: '0.8125rem' },
                                        }}>
                                        Recommended image size: {DESIRED_IMAGE_WIDTH} × {DESIRED_IMAGE_HEIGHT} px. Max file
                                        size 256 KB.
                                    </Alert>
                                </Box>
                            </SimpleItem>
                            {!hasExistingImage && (
                                <SimpleItem>
                                    <div className='image-container'>
                                        {selectedPreviewUrl ? (
                                            <img src={selectedPreviewUrl} alt='Preview' className='image-preview' />
                                        ) : (
                                            <Typography variant='body2' color='text.secondary'>
                                                No image selected
                                            </Typography>
                                        )}
                                    </div>
                                </SimpleItem>
                            )}
                            {!hasExistingImage && (
                                <SimpleItem
                                    cssClass='imageStyling'
                                    dataField='file'
                                    editorType='dxFileUploader'
                                    validationRules={validationRules.file}
                                    editorOptions={{
                                        uploadMode: 'useForm',
                                        multiple: 'false',
                                        selectButtonText: 'Select File',
                                        labelText: '',
                                        accept: 'image/*',
                                        allowedFileExtensions: ['.jpg', '.jpeg', '.png'],
                                        maxFileSize: 1024 * 512,
                                        onValueChanged: (e) => {
                                            const file = e?.value?.[0]
                                            props.onSelectedFileChange?.(file ?? null)
                                            setSelectedPreviewUrl((prev) => {
                                                if (prev) URL.revokeObjectURL(prev)
                                                return file ? URL.createObjectURL(file) : null
                                            })
                                        },
                                    }}>
                                    <Label text='Select an Image (800x1300px)' />
                                </SimpleItem>
                            )}
                            {hasExistingImage && (
                                <SimpleItem>
                                    <div className='image-container'>
                                        <img src={props.filePathSearchData} alt='Preview' className='image-preview' />
                                    </div>
                                </SimpleItem>
                            )}
                        </GroupItem>
                    </GroupItem>
                    <EmptyItem />
                    <GroupItem>
                        <ColCountByScreen lg={2} md={2} sm={2} xs={2} />
                        <ButtonItem buttonOptions={submitButtonOptionsSearch} horizontalAlignment='right' />
                        <ButtonItem buttonOptions={deleteButtonOptionsSearch} horizontalAlignment='left' />
                    </GroupItem>
                </Form>
            </form>
        </React.Fragment>
    )
}

export default ChangeSearchImageUpload
